export interface ILanguage {
  name: string;
  code: string;
  flag: string;
}

export const Languages: ILanguage[] = [
  { name: 'Afar', code: 'aa', flag: 'https://flagcdn.com/w40/et.png' },
  { name: 'Abkhazian', code: 'ab', flag: 'https://flagcdn.com/w40/ge.png' },
  { name: 'Avestan', code: 'ae', flag: 'https://flagcdn.com/w40/ir.png' },
  { name: 'Afrikaans', code: 'af', flag: 'https://flagcdn.com/w40/za.png' },
  { name: 'Akan', code: 'ak', flag: 'https://flagcdn.com/w40/gh.png' },
  { name: 'Amharic', code: 'am', flag: 'https://flagcdn.com/w40/et.png' },
  { name: 'Arabic', code: 'ar', flag: 'https://flagcdn.com/w40/sa.png' },
  { name: 'Assamese', code: 'as', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Aymara', code: 'ay', flag: 'https://flagcdn.com/w40/bo.png' },
  { name: 'Azerbaijani', code: 'az', flag: 'https://flagcdn.com/w40/az.png' },

  { name: 'Belarusian', code: 'be', flag: 'https://flagcdn.com/w40/by.png' },
  { name: 'Bulgarian', code: 'bg', flag: 'https://flagcdn.com/w40/bg.png' },
  { name: 'Bambara', code: 'bm', flag: 'https://flagcdn.com/w40/ml.png' },
  { name: 'Bengali', code: 'bn', flag: 'https://flagcdn.com/w40/bd.png' },
  { name: 'Tibetan', code: 'bo', flag: 'https://flagcdn.com/w40/cn.png' },
  { name: 'Bosnian', code: 'bs', flag: 'https://flagcdn.com/w40/ba.png' },

  { name: 'Catalan', code: 'ca', flag: 'https://flagcdn.com/w40/es.png' },
  { name: 'Czech', code: 'cs', flag: 'https://flagcdn.com/w40/cz.png' },
  { name: 'Welsh', code: 'cy', flag: 'https://flagcdn.com/w40/gb.png' },

  { name: 'Danish', code: 'da', flag: 'https://flagcdn.com/w40/dk.png' },
  { name: 'German', code: 'de', flag: 'https://flagcdn.com/w40/de.png' },
  { name: 'Greek', code: 'el', flag: 'https://flagcdn.com/w40/gr.png' },
  { name: 'English', code: 'en', flag: 'https://flagcdn.com/w40/gb.png' },
  { name: 'Spanish', code: 'es', flag: 'https://flagcdn.com/w40/es.png' },
  { name: 'Estonian', code: 'et', flag: 'https://flagcdn.com/w40/ee.png' },
  { name: 'Basque', code: 'eu', flag: 'https://flagcdn.com/w40/es.png' },

  { name: 'Persian', code: 'fa', flag: 'https://flagcdn.com/w40/ir.png' },
  { name: 'Finnish', code: 'fi', flag: 'https://flagcdn.com/w40/fi.png' },
  { name: 'French', code: 'fr', flag: 'https://flagcdn.com/w40/fr.png' },

  { name: 'Irish', code: 'ga', flag: 'https://flagcdn.com/w40/ie.png' },
  { name: 'Galician', code: 'gl', flag: 'https://flagcdn.com/w40/es.png' },
  { name: 'Gujarati', code: 'gu', flag: 'https://flagcdn.com/w40/in.png' },

  { name: 'Hebrew', code: 'he', flag: 'https://flagcdn.com/w40/il.png' },
  { name: 'Hindi', code: 'hi', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Croatian', code: 'hr', flag: 'https://flagcdn.com/w40/hr.png' },
  { name: 'Hungarian', code: 'hu', flag: 'https://flagcdn.com/w40/hu.png' },

  { name: 'Indonesian', code: 'id', flag: 'https://flagcdn.com/w40/id.png' },
  { name: 'Icelandic', code: 'is', flag: 'https://flagcdn.com/w40/is.png' },
  { name: 'Italian', code: 'it', flag: 'https://flagcdn.com/w40/it.png' },

  { name: 'Japanese', code: 'ja', flag: 'https://flagcdn.com/w40/jp.png' },
  { name: 'Georgian', code: 'ka', flag: 'https://flagcdn.com/w40/ge.png' },
  { name: 'Kazakh', code: 'kk', flag: 'https://flagcdn.com/w40/kz.png' },
  { name: 'Khmer', code: 'km', flag: 'https://flagcdn.com/w40/kh.png' },
  { name: 'Kannada', code: 'kn', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Korean', code: 'ko', flag: 'https://flagcdn.com/w40/kr.png' },

  { name: 'Lithuanian', code: 'lt', flag: 'https://flagcdn.com/w40/lt.png' },
  { name: 'Latvian', code: 'lv', flag: 'https://flagcdn.com/w40/lv.png' },

  { name: 'Malayalam', code: 'ml', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Marathi', code: 'mr', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Malay', code: 'ms', flag: 'https://flagcdn.com/w40/my.png' },

  { name: 'Dutch', code: 'nl', flag: 'https://flagcdn.com/w40/nl.png' },
  { name: 'Norwegian', code: 'no', flag: 'https://flagcdn.com/w40/no.png' },

  { name: 'Punjabi', code: 'pa', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Polish', code: 'pl', flag: 'https://flagcdn.com/w40/pl.png' },
  { name: 'Portuguese', code: 'pt', flag: 'https://flagcdn.com/w40/pt.png' },

  { name: 'Romanian', code: 'ro', flag: 'https://flagcdn.com/w40/ro.png' },
  { name: 'Russian', code: 'ru', flag: 'https://flagcdn.com/w40/ru.png' },

  { name: 'Sinhala', code: 'si', flag: 'https://flagcdn.com/w40/lk.png' },
  { name: 'Slovak', code: 'sk', flag: 'https://flagcdn.com/w40/sk.png' },
  { name: 'Slovenian', code: 'sl', flag: 'https://flagcdn.com/w40/si.png' },
  { name: 'Albanian', code: 'sq', flag: 'https://flagcdn.com/w40/al.png' },
  { name: 'Serbian', code: 'sr', flag: 'https://flagcdn.com/w40/rs.png' },
  { name: 'Swedish', code: 'sv', flag: 'https://flagcdn.com/w40/se.png' },

  { name: 'Tamil', code: 'ta', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Telugu', code: 'te', flag: 'https://flagcdn.com/w40/in.png' },
  { name: 'Thai', code: 'th', flag: 'https://flagcdn.com/w40/th.png' },
  { name: 'Turkish', code: 'tr', flag: 'https://flagcdn.com/w40/tr.png' },

  { name: 'Ukrainian', code: 'uk', flag: 'https://flagcdn.com/w40/ua.png' },
  { name: 'Urdu', code: 'ur', flag: 'https://flagcdn.com/w40/pk.png' },
  { name: 'Vietnamese', code: 'vi', flag: 'https://flagcdn.com/w40/vn.png' },
  { name: 'Chinese', code: 'zh', flag: 'https://flagcdn.com/w40/cn.png' },
  { name: 'Zulu', code: 'zu', flag: 'https://flagcdn.com/w40/za.png' },
];
